import ReactDOM from 'react-dom';

class SMClickOutsideObserver {
  
  constructor(component) {
    this.component = component;
  }
  
  attach(callback) {
    this.callback = callback;
    this.addLocalComponentClickObserver();
    this.addDocumentClickObserver();
  }
  
  detach() {
    this.removeLocalComponentClickObserver();
    this.removeDocumentClickObserver();
  }
  
  addDocumentClickObserver() {
    $(document).on("mousedown", this.documentDidClick.bind(this));
    $(document).on("touchstart", this.documentDidClick.bind(this));
  }
  
  addLocalComponentClickObserver() {
    $(ReactDOM.findDOMNode(this.component)).on("mousedown", this.localComponentDidClick.bind(this));
    $(ReactDOM.findDOMNode(this.component)).on("touchstart", this.localComponentDidClick.bind(this));
  }
  
  removeDocumentClickObserver() {
    $(document).off("mousedown", this.documentDidClick.bind(this));
    $(document).off("touchstart", this.documentDidClick.bind(this));
  }
  
  removeLocalComponentClickObserver() {
    $(ReactDOM.findDOMNode(this.component)).off("mousedown", this.localComponentDidClick.bind(this));
    $(ReactDOM.findDOMNode(this.component)).off("touchstart", this.localComponentDidClick.bind(this));
  }
  
  documentDidClick(e) {
    $(document).trigger("SMHideBaloon");
    this.callback(e);
  }
  
  localComponentDidClick(e) {
    e.stopPropagation();
  }

}
export default SMClickOutsideObserver;



// WEBPACK FOOTER //
// ./app/javascript/lib/SMClickOutsideObserver.js